export default function getLinkPath(urlKey, parent, grandparent) {
  const path = `/kataloog/${grandparent ? grandparent + '/' : ''}${
    parent ? parent + '/' : ''
  }${urlKey}`;

  return path;
}
